import React, { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { registerUser } from '../services/api';

export default function RegisterPage() {
  const [searchParams] = useSearchParams();
  const inviteCode = searchParams.get('invite') || '';

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (password !== password2) { setError('Passwörter stimmen nicht überein'); return; }
    if (password.length < 8) { setError('Passwort muss mindestens 8 Zeichen haben'); return; }
    setLoading(true);
    try {
      const data = await registerUser(email, password, name, inviteCode);
      login(data.access_token, { id: data.user_id, name: data.name, email: data.email });
      navigate('/analyse');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  if (!inviteCode) {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <div className="auth-logo">
            <h1>Caisar</h1>
            <p>Medizinischer KI-Assistent</p>
          </div>
          <div className="auth-form">
            <h2>Zugang nur auf Einladung</h2>
            <p style={{ color: '#6b7280', marginTop: '8px', fontSize: '14px' }}>
              Um ein Konto zu erstellen, benötigst du einen Einladungslink.
              Bitte wende dich an den Administrator.
            </p>
            <p className="auth-switch" style={{ marginTop: '24px' }}>
              Bereits registriert? <Link to="/login">Anmelden</Link>
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">
          <h1>Caisar</h1>
          <p>Medizinischer KI-Assistent</p>
        </div>
        <form onSubmit={handleSubmit} className="auth-form">
          <h2>Konto erstellen</h2>
          {error && <p className="auth-error">{error}</p>}
          <div className="auth-field">
            <label>Name</label>
            <input
              type="text" value={name} onChange={e => setName(e.target.value)}
              placeholder="Dr. Max Mustermann" required autoFocus
            />
          </div>
          <div className="auth-field">
            <label>E-Mail</label>
            <input
              type="email" value={email} onChange={e => setEmail(e.target.value)}
              placeholder="arzt@praxis.de" required
            />
          </div>
          <div className="auth-field">
            <label>Passwort</label>
            <input
              type="password" value={password} onChange={e => setPassword(e.target.value)}
              placeholder="Mindestens 8 Zeichen" required
            />
          </div>
          <div className="auth-field">
            <label>Passwort bestätigen</label>
            <input
              type="password" value={password2} onChange={e => setPassword2(e.target.value)}
              placeholder="••••••••" required
            />
          </div>
          <button type="submit" className="auth-btn" disabled={loading}>
            {loading ? 'Konto wird erstellt…' : 'Konto erstellen'}
          </button>
        </form>
        <p className="auth-switch">
          Bereits registriert? <Link to="/login">Anmelden</Link>
        </p>
      </div>
    </div>
  );
}
